import { format } from "date-fns/format";
import { parse } from "date-fns/parse";
const intlLocation = (location)=>location && 'string' == typeof location.countryCode && 'US' !== location.countryCode.toUpperCase();
const isInfantFound = (childrenAges)=>Object.values(childrenAges).some((age)=>{
        const childAge = Number.parseInt(age, 10);
        return !Number.isNaN(childAge) && 0 === childAge;
    });
const isLocationWithInfant = (locationObject, childrenAges)=>intlLocation(locationObject) && isInfantFound(childrenAges);
const formatDate = ({ dateStr, dateFormat = 'MM/dd/yyyy' })=>{
    let formattedDate = '';
    try {
        if (dateStr) formattedDate = format(parse(dateStr, 'yyyyMMdd', new Date()), dateFormat);
    } catch  {
        formattedDate = '';
    }
    return formattedDate;
};
export { formatDate, intlLocation, isInfantFound, isLocationWithInfant };
